<template>
    <v-card>
        <v-card-title>
            <span>Enrollar Huella</span>
        </v-card-title>
        <v-card-text>
            <v-row class="result-container my-10 fixed-height">
                <v-card class="">
                    <v-card-text class="d-flex flex-column align-center">
                        <v-col cols="12" class="d-flex flex-column align-center">
                            <span class="text-h5 mb-3">{{ FpVariantToName[variant] }}</span>
                            <div :class="`big-finger big`">
                                <v-icon>mdi-fingerprint</v-icon>
                            </div>
                        </v-col>
                        <v-progress-circular x-large v-if="isConnecting || isScanning" indeterminate color="primary"
                            class="my-5"></v-progress-circular>
                        <p class="font-weight-bold text-h5 text-center">{{ title }}</p>
                        <p class="font-weight-medium">{{ message }}</p>
                    </v-card-text>
                </v-card>
            </v-row>
            <div class="attend-actions mt" v-if="isConnected">
                <v-btn @click="scanEnroll" x-large color="primary" :loading="isScanning"
                    :disabled="isScanning || isSaving">Escanear
                    Huella</v-btn>

                <v-card class="mt-5">
                    <v-card-text class="d-flex flex-column align-center">
                        <battery-level :battery-percentage="deviceBattery" />
                        <span class="text-p mt-4">Dispositivo: {{ deviceName }}</span>
                    </v-card-text>
                </v-card>
            </div>
            <div class="attend-actions" v-else>
                <v-btn @click="connectDevice" x-large color="primary" :disabled="isConnecting"
                    :loading="isConnecting">Connectar Dispositivo</v-btn>
            </div>
        </v-card-text>
        <v-card-actions class="pt-10">
            <v-btn color="blue darken-1" text @click="onClose">Salir</v-btn>
            <v-spacer></v-spacer>
        </v-card-actions>
    </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import { FpVariantToName } from '../services/constData';
import BatteryLevel from './Misc/BatteryLevel.vue';
export default {
    name: 'EmpFpEnroll',
    components: {
        BatteryLevel
    },
    props: {
        emp: Object,
        variant: Number
    },
    emits: ['close'],
    data() {
        return {
            FpVariantToName,
            isSaving: false
        };
    },
    computed: {
        ...mapGetters(['isScanning', 'isConnected', 'isConnecting', 'isChoosingDevice', 'deviceBattery', 'deviceName']),
        batteryColor() {
            if (this.batteryPercentage < 20) return 'red';
            if (this.batteryPercentage < 40) return 'orange';
            return 'green';
        },
        title() {
            if (this.isSaving) {
                return 'Subiendo datos de huella al sistema'
            }
            if (this.isConnecting) {
                return 'Conectando dispositivo por favor espere'
            }
            if (this.isChoosingDevice) {
                return 'Elija el dispositivo cuyo nombre comience con "IBS"'
            }
            if (!this.isConnected) {
                return 'Conecte el lector de huellas'
            }
            if (this.isScanning) {
                return 'Escaneando huella'
            }
            if (this.isMatching) {
                return 'Verificando huella'
            }
            return 'Listo para escanear'

        },
        message() {
            if (this.isSaving) {
                return ''
            }
            if (this.isChoosingDevice) {
                return ''
            }
            if (!this.isConnected) {
                return 'Encienda el lector de huellas y haga clic en el botón Conectar'
            }
            if (this.isScanning) {
                return 'Por favor, coloque su dedo en el lector de huellas'
            }
            if (this.isMatching) {
                return 'Buscando empleado'
            }
            return 'Haga clic en el botón Escanear Huella'
        }
    },
    methods: {
        async scanEnroll() {
            const data = await this.$store.dispatch('enrollFp');
            this.isSaving = true;
            await this.$store.dispatch('saveEmpFp', { empId: this.emp._id, data, variant: this.variant });
            this.isSaving = false;
            this.$emit('close');
        },
        onClose() {
            this.$emit('close');
        },
        connectDevice() {
            this.$store.dispatch('connectDevice');
        },
    }
};
</script>

<style scoped>
/* Add your component-specific styles here */
</style>